import Vue from 'vue';
import Router from 'vue-router';

import Login from '@/components/auth/Login';
import PrimaryRegistration from '@/components/auth/PrimaryRegistration';
import Registration from '@/components/auth/Registration';
import Recover from '@/components/auth/Recover';
import PasswordChange from '@/components/auth/PasswordChange';
import WidgetSettings from '@/components/WidgetSettings';
import Calculator from '@/components/Calculator';
import DeliveryServices from '@/components/deliveryServices/DeliveryServices';
import EditDeliveryService from '@/components/deliveryServices/EditDeliveryService';
import EditManualDeliveryMethod from '@/components/deliveryServices/EditManualDeliveryMethod';
import EditManualPvz from '@/components/deliveryServices/EditManualPvz';
import Promocodes from '@/components/promocodes/Promocodes';
import EditPromocode from '@/components/promocodes/EditPromocode';
import CostRules from '@/components/costRules/CostRules';
import EditCostRule from '@/components/costRules/EditCostRule';
import Products from '@/components/products/Products';
import UserInfo from '@/components/users/UserInfo';
import EditShop from '@/components/shops/EditShop';
import Payment from '@/components/payments/Payment';
import TariffPlan from '@/components/payments/TariffPlan';
import Finance from '@/components/finance/Finance';
import InSalesIntegration from '@/components/integration/InSalesIntegration';
import PartnerShops from '@/components/partners/PartnerShops';
import OrdersTransferList from '@/components/ordersTransfer/OrdersTransferList';
import EditOrder from '@/components/ordersTransfer/EditOrder';

import store from '@/store/index';

Vue.use(Router);

const externalRoutes = [{
    path: '/login',
    component: Login
}, {
    path: '/begin_registration',
    component: PrimaryRegistration
}, {
    path: '/registration',
    component: Registration
}, {
    path: '/recover',
    component: Recover
}, {
    path: '/recover/:token',
    component: PasswordChange
}];

for (let item of externalRoutes) item.meta = { ...item.meta, withoutAuth: true };

const internalRoutes = [{
    path: '/widget/',
    component: WidgetSettings
}, {
    path: '/calculator/',
    component: Calculator
}, {
    path: '/delivery_services/',
    component: DeliveryServices
}, {
    path: '/delivery_services/edit/',
    component: EditDeliveryService
}, {
    path: '/delivery_services/manual/edit/',
    component: EditManualDeliveryMethod
}, {
    path: '/delivery_services/manual/pvz/edit/',
    component: EditManualPvz
}, {
    path: '/promocodes/',
    component: Promocodes
}, {
    path: '/promocodes/edit/',
    component: EditPromocode
}, {
    path: '/cost_rules/',
    component: CostRules
}, {
    path: '/cost_rules/edit/',
    component: EditCostRule
}, {
    path: '/products/',
    component: Products
}, {
    path: '/profile/',
    component: UserInfo
}, {
    path: '/shop/info/',
    props: true,
    component: EditShop
}, {
    path: '/tariff_plan/pay/',
    component: Payment
}, {
    path: '/tariff_plan/',
    component: TariffPlan
}, {
    path: '/finance/',
    component: Finance
}, {
    path: '/integration/insales/',
    component: InSalesIntegration
}, {
    path: '/partner/',
    component: PartnerShops
}, {
    path: '/orders_transfer/',
    component: OrdersTransferList
}, {
    path: '/orders_transfer/:salesbeatOrderId/',
    component: EditOrder,
    props: true
}];

const routes = internalRoutes.concat(externalRoutes);
for (let item of routes) item.name = item.component.name;

const router = new Router({
    routes
});

const MENU_ITEMS = [
    'Calculator',
    'DeliveryServices',
    'Promocodes',
    'CostRules',
    'WidgetSettings',
    'Products',
    'EditShop',
    'OrdersTransferList'
];

const NAVBAR_ITEMS = [
    'UserInfo',
    'TariffPlan'
];

const NAVBAR_OR_MENU = [].concat(MENU_ITEMS, NAVBAR_ITEMS);

let selectMenuItem = (to) => {
    if (NAVBAR_OR_MENU.includes(to.name)) {
        store.commit('selectMenuItem', to.name);
    }
};

router.beforeEach((to, from, next) => {
    if (
        !to.meta.withoutAuth &&
        store.state.authentication.loginCheckCompleted &&
        !store.state.authentication.isLoggedIn
    ) {
        // Если пользователь не залогинен и находится не на общедоступных страницах
        // – редиректим его на страницу логинки
        next({name: 'Login'});
        return;
    }

    if (
        to.meta.withoutAuth &&
        store.state.authentication.loginCheckCompleted &&
        store.state.authentication.isLoggedIn
    ) {
        // Если пользователь залогинен и пытается перейти на страницу,
        // не требующую аутентификации – редиректим его на `/`
        next({name: 'DeliveryServices'});
        return;
    }

    selectMenuItem(to);

    next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js